import React from 'react';
import { Link } from 'react-router-dom';
import { APP_NAME } from '../../../config/appConstants';
import appLogo from '../../../assets/images/DevicePulse-app-logo2.png';
import Footer from '../common/Footer';
import './PublicInfoLayout.css';

function isSignedIn() {
  try {
    return Boolean(sessionStorage.getItem('token') && sessionStorage.getItem('user'));
  } catch {
    return false;
  }
}

export default function PublicInfoLayout({ children }) {
  const signedIn = isSignedIn();

  return (
    <div className="public-info-page">
      <header className="public-info-header">
        <div className="public-info-header-inner">
          <Link className="public-info-brand" to="/" aria-label={APP_NAME}>
            <img src={appLogo} alt="" />
            <span className="public-info-brand-title">{APP_NAME}</span>
          </Link>

          <nav className="public-info-actions" aria-label="Account">
            {signedIn ? (
              <Link className="public-info-action-link" to="/">Back to app</Link>
            ) : (
              <Link className="public-info-action-link" to="/login">Sign in</Link>
            )}
          </nav>
        </div>
      </header>

      <main className="public-info-main">
        <div className="public-info-content">
          <div className="public-info-card legal-card">
            {children}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
